import { ALL_INVESTMENT_TYPES, PHYSICAL_TYPES, FINANCIAL_TYPES } from './colors';

export function deriveTierState(filter: string[]): { physicalOn: boolean; financialOn: boolean } {
  if (filter.length === 0) return { physicalOn: true, financialOn: true };
  return {
    physicalOn: PHYSICAL_TYPES.some(t => filter.includes(t)),
    financialOn: FINANCIAL_TYPES.some(t => filter.includes(t)),
  };
}

export function toggleTier(currentFilter: string[], tier: 'physical' | 'financial'): string[] {
  const tierTypes = tier === 'physical' ? PHYSICAL_TYPES : FINANCIAL_TYPES;

  // Expand empty filter to explicit list for manipulation
  const active = currentFilter.length === 0 ? [...ALL_INVESTMENT_TYPES] : [...currentFilter];

  const tierIsOn = tierTypes.some(t => active.includes(t));

  let result: string[];
  if (tierIsOn) {
    result = active.filter(t => !tierTypes.includes(t));
    // Don't allow empty result — at least one tier must stay on
    if (result.length === 0) return currentFilter;
  } else {
    result = [...active, ...tierTypes];
  }

  // If result contains all known types, collapse to [] (show all)
  if (ALL_INVESTMENT_TYPES.every(t => result.includes(t))) {
    return [];
  }

  return result;
}

export const DEFAULT_INVESTMENT_TYPES = [...PHYSICAL_TYPES];
